import { DEFAULT_COUNT_ON_PAGE } from '@shared/ui/pagination/constants';
import {
    UserProfileOptionDataRequest,
    UserProfileOptionsDataOrder,
    UserProfileOptionsDataSort,
} from '../api/user-profile-option-types';
import { UserProfileOptionType } from '@shared/model/user-profile-option';

export const DEFAULT_USER_PROFILE_OPTIONS_LIST_PARAMETERS: UserProfileOptionDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    active: true,
    type: UserProfileOptionType.Department,
    order: UserProfileOptionsDataOrder.Name,
    sort: UserProfileOptionsDataSort.Asc,
};

export const DEFAULT_USER_PROFILE_OPTIONS_PUBLIC_LIST_PARAMETERS: UserProfileOptionDataRequest = {
    search: '',
    take: DEFAULT_COUNT_ON_PAGE.value,
    skip: null,
    order: UserProfileOptionsDataOrder.Name,
    sort: UserProfileOptionsDataSort.Asc,
};
